<ng-container *ngIf="order$ | async as order">
  <div class="row justify-content-end">
    <div class="cx-summary col-sm-12">
      <sd-order-summary [cart]="order"></sd-order-summary>
    </div>
  </div>
</ng-container>
